// Version : 0.0.1
// Author : SATHISH
// LastEdit : KARTHEESWARAN
// MODFIED DATE:26-08-2025
import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/*************** ACCOUNT DETAILS ADD START *************** */
export const accountDetailsAdd = (addData: any) => {
	const data = {
		CreateAccountToken: addData,
	};
	const url = `${FIN_API_URL}createAccount`;
	return makeApiCall(url, data);
};
/*************** ACCOUNT DETAILS ADD END *************** */

/*************** ACCOUNT DETAILS UPDATE START *************** */
export const accountDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateAllAccountListToken: updateData,
	};
	const url = `${FIN_API_URL}updateAccount`;
	return makeApiCall(url, data);
};
/*************** ACCOUNT DETAILS UPDATE END *************** */

/*************** ACCOUNT DETAILS GET START *************** */
export const accountListGet = (listData: any) => {
	const data = {
		GetAllAccountListToken: listData,
	};
	const url = `${FIN_API_URL}postGetAllAccountList`;
	return makeApiCall(url, data);
};

/*************** ACCOUNT DETAILS DELETE START *************** */
export const accountDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteAccountToken: deleteData,
	};
	const url = `${FIN_API_URL}deleteAccount`;
	return makeApiCall(url, data);
};
/*************** ACCOUNT DETAILS DELETE END *************** */
